import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
/**
 * Base Text Field Component
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since v0.0.1
 */
let BaseTextFieldIndex = class BaseTextFieldIndex extends Vue {
    /**
     * Method for triggering event emitter
     */
    hasInput(input) {
        /**
         * Emit hasInput Event
         */
        this.$emit('hasInput', input);
    }
    /**
     * Trigger Event upon enter
     */
    wasEntered() {
        /**
         * Triggered Event upon click
         * @event wasEntered
         * @type { never }
         */
        this.$emit('wasEntered');
    }
};
__decorate([
    Prop({ required: true, default: null })
], BaseTextFieldIndex.prototype, "value", void 0);
__decorate([
    Prop({ type: String, required: true })
], BaseTextFieldIndex.prototype, "label", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextFieldIndex.prototype, "required", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseTextFieldIndex.prototype, "prefix", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextFieldIndex.prototype, "outline", void 0);
__decorate([
    Prop({ type: String })
], BaseTextFieldIndex.prototype, "id", void 0);
__decorate([
    Prop({ type: Array })
], BaseTextFieldIndex.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: Boolean })
], BaseTextFieldIndex.prototype, "solo", void 0);
__decorate([
    Prop({ type: String, required: false })
], BaseTextFieldIndex.prototype, "hint", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextFieldIndex.prototype, "persistentHint", void 0);
BaseTextFieldIndex = __decorate([
    Component({
        name: 'BaseTextField',
    })
], BaseTextFieldIndex);
export default BaseTextFieldIndex;
